export default __webpack_public_path__ + "static/media/selectDestinationArraial.1290321f.svg";